/**
 * Join two path segments, collapsing the slash boundary so neither caller has to
 * remember whether the left already ends in `/` or the right already starts with one.
 *
 *   pathJoin('/a',   'b')   → '/a/b'
 *   pathJoin('/a/',  'b')   → '/a/b'
 *   pathJoin('/a',   '/b')  → '/a/b'
 *   pathJoin('/a/',  '/b')  → '/a/b'
 *   pathJoin('/a//', '//b') → '/a/b'
 *   pathJoin('',     'b')   → 'b'
 *   pathJoin('/a',   '')    → '/a'
 *
 * Mirrors the slash behavior of Node's `path.posix.join`, but does NOT
 * normalize `.` or `..` — segments are concatenated literally.
 *
 * Two parameters only. Chain calls (or build named intermediates) for longer
 * paths — open-ended joins almost always indicate a missing domain abstraction.
 */
export const pathJoin = (a: string, b: string): string => {
  if (a === '') return b;
  if (b === '') return a;
  const left = a.replace(/\/+$/, '');
  const right = b.replace(/^\/+/, '');
  return `${left}/${right}`;
};
